import { css } from 'styled-components';

// TODO don't export these, use TYPOGRAPHY.OPEN_SANS and TYPOGRAPHY.CIRCULAR instead
// We're keeping this for `style-constants.js` to use
export const OPEN_SANS_FONT_FAMILY = '\'Open Sans\', sans-serif';
export const CIRCULAR_FONT_FAMILY = `'Circular Std', ${OPEN_SANS_FONT_FAMILY}`;

const FONT_WEIGHT = {
  thin: 300,
  base: 400,
  normal: 500,
  semiBold: 600,
  bold: 700,
  black: 900,
};

/*
  These are the weights we have font files for
  Don't add to this unless you add the correct font files
*/
const CIRCULAR = {
  book: css`
    font-family: ${CIRCULAR_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.normal};
  `,

  bold: css`
    font-family: ${CIRCULAR_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.bold};
  `,

  black: css`
    font-family: ${CIRCULAR_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.black};
  `,
};

/*
  Open Sans is a variable font, so we can use any weight between 300 and 800
  Setting a base font-variation wght to match the font-weight allows us to transition
  font-variation-settings
*/
const OPEN_SANS = {
  thin: css`
    font-family: ${OPEN_SANS_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.thin};
    font-variation-settings: 'wght' ${FONT_WEIGHT.thin};
  `,

  base: css`
    font-family: ${OPEN_SANS_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.base};
    font-variation-settings: 'wght' ${FONT_WEIGHT.base};
  `,

  semiBold: css`
    font-family: ${OPEN_SANS_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.semiBold};
    font-variation-settings: 'wght' ${FONT_WEIGHT.semiBold};
  `,

  bold: css`
    font-family: ${OPEN_SANS_FONT_FAMILY};
    font-weight: ${FONT_WEIGHT.bold};
    font-variation-settings: 'wght' ${FONT_WEIGHT.bold};
  `,
};

export const TYPOGRAPHY = {
  CIRCULAR,
  OPEN_SANS,
};
